/**
 * Engagement evidence request bodies. (W5.8)
 *
 * The redaction vocabulary is `EVIDENCE_REDACTION_REASONS` in
 * `@tonnie/foundation`; it is restated here because this package depends on
 * zod alone. `engagement-evidence-vocabulary.spec.ts` in platform-api asserts
 * the two lists are identical, so they cannot drift.
 */

import { z } from 'zod';

/** POST …/talents/:talentId/evidence-captures — an explicit, on-demand capture. */
export const captureEngagementEvidenceSchema = z.strictObject({
  /**
   * Which relationship; omitted = the talent's primary live one with this
   * company. `guid`, not `uuid`: zod v4's `uuid()` enforces the RFC 4122
   * version nibble, and seeded fixture ids carry version 0.
   */
  journeyId: z.guid().optional(),
});

export type CaptureEngagementEvidenceInput = z.infer<typeof captureEngagementEvidenceSchema>;

/** POST …/evidence-captures/:captureId/items/:itemId/redact */
export const redactEvidenceItemSchema = z.strictObject({
  reason: z.enum(['data_subject_request', 'legal_obligation', 'controller_minimisation']),
});

export type RedactEvidenceItemInput = z.infer<typeof redactEvidenceItemSchema>;
